<template>
    <div>
        <div class="resourceApplication-title">
            <div>{{$t('resourceLifecycle.resourceApplication')}}</div>
        </div>
        <!-- 基本信息 -->
        <basic-information></basic-information>
    </div>
</template>

<script>
    import BasicInformation from '../resource_application/BasicInformation'
    export default {
        components: {
            BasicInformation
        }
    }
</script>

<style scoped>
    .resourceApplication-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 15px 4px;
        font-weight: 600;
        overflow: hidden;
    }
    .resourceApplication-title>div:nth-child(1)
    {
        float:left;
    }
</style>



// WEBPACK FOOTER //
// src/components/resource_lifecycle_management/resource_application/ResourceApplication.vue